import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

import AddOrganisation from '../components/child/AddOrganisation';


const AddOrganisationPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Add Organisation" />

        {/* InputStatus */}
        <AddOrganisation />

      </MasterLayout>

    </>
  );
};

export default AddOrganisationPage; 
